import React, { Component } from "react";

import './noticiasEventos.css';

import PropTypes from 'prop-types';

import Botao from '../utils/Botao';


class NoticiaEventoSmall extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  elementClicked = () => {
    this.context.router.history.push("/noticias_e_eventos/" + this.props.item.identifier);
  }

  stripHTMLTags = (text) => {
    console.log(text);
    if(text === null || text === ''){
      return '';
    }
    else{
      let description = text;
      description = description.replace(/<[^>]*>/g, '');
      description = description.replace(/(?:^|\W)&nbsp(?:$|\W)/, '');
      if(description.length > 250){
        description = description.substr(0, 250) + "\u2026";
      }
      return description;
    }
  }

  renderTipoNoticia = (type) => {

    if(type === 'NOTICIA'){
      return('Notícia');
    } else if(type === 'PROJETO'){
      return('Projeto');
    } else {
      return('Evento')
    }

  }


  render() {
    return (
      <div onClick={this.elementClicked} id="noticiaSmall" className="col-sm-6 col-md-4">
        <div className="box-shadow">
          <div className="imagem-noticia">
            <div className="div-tipo">
              <span className="text-tipo">{this.renderTipoNoticia(this.props.item.type)}</span>
            </div>
            <img src={this.props.item.mainPhoto} className="fitImageNoticia" alt="Imagem Notícia" />
          </div>
          <div className="elemento-noticia">
            <p className="titulo">{this.props.item.title}</p>
            <p className="texto">
              {this.stripHTMLTags(this.props.item.description)}
            </p>
          </div>
          <div className="col-12 footer-noticia">
            <Botao></Botao>
          </div>
        </div>
      </div>
    );
  }
}

export default NoticiaEventoSmall;
